export enum SubscriptionDetailTab {
  CONFIG = "config",
  GRAPHIC_VIEW = "graphic-view",
  SYSTEM_STATS = "system-stats",
}
